{
  "WALLBOARD": {
    "LOADING": "Nalaganje telefonskih čakalnih vrst ...",
    "NO_QUEUES": "Ni najdenih telefonskih čakalnih vrst.",
    "NO_AGENTS": "V tej čakalni vrsti trenutno ni agentov na spletu.",
    "UNKNOWN_CALLER": "Neznani klicatelj",
    "STATUS": "Stanje",
    "TIME": "Čas",
    "AGENT": "Agent",
    "EXTENSION": "Interna številka",
    "READY": "Pripravljeni agenti",
    "ON_CALL": "Agenti na klicu",
    "PAUSED": "Agenti na odmoru",
    "WAITING": "Klici v čakanju",
    "MISSED_CALLS": "Zgrešeni klici",
    "HANDLED_CALLS": "Obravnavani dohodni klici",
    "OUTBOUND_CALLS": "Obravnavani odhodni klici",
    "AVAILABILITY": "Razpoložljivost",
    "AVAILABILITY_TOOLTIP": "Odstotek dohodnih klicev, na katere so odgovorili agenti (prevzeti klici)",
    "AGENTS_COUNT": "({onCall} na klicu / {total} skupaj)",
    "NO_AVAILABLE": "(nihče na spletu)",
    "WAITING_CALLERS_COUNT": "{count} čaka",
    "CALLER": "Klicatelj",
    "NUMBER": "Številka",
    "WAIT_TIME": "Čas čakanja",
    "ACTION": "Dejanje",
    "PICKUP_CALL": "Prevzemi",
    "PICKUP_SUCCESS": "Zahteva za prevzem klica je bila uspešno poslana.",
    "PICKUP_ERROR": "Prevzem klica ni uspel. Poskusite znova.",
    "PICKUP_DISABLED_TOOLTIP": "Klica ne morete prevzeti, medtem ko ste na klicu ali brez povezave.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Brez dostopa"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Brez dostopa"
    }
  }
}
